// Mobile Menu Toggle and Header Shadow
document.addEventListener('DOMContentLoaded', () => {
  const headerWrapper = document.querySelector('header.wp-block-template-part');
  const headerGroup = document.querySelector('.wp-block-group.header');
  const navWrapper = document.querySelector('.nav-wrapper');
  const navigation = document.querySelector('.wp-block-navigation');
  const buttons = document.querySelector('.wp-block-buttons');
  
  if (!headerGroup || !navWrapper) return;

  // Add scroll shadow effect
  const handleScroll = () => {
    if (window.scrollY > 0) {
      headerWrapper?.classList.add('scrolled');
    } else {
      headerWrapper?.classList.remove('scrolled');
    }
  };

  // Initial check
  handleScroll();

  // Add scroll event listener
  window.addEventListener('scroll', handleScroll, { passive: true });

  // Create mobile menu toggle button
  const toggleButton = document.createElement('button');
  toggleButton.className = 'mobile-menu-toggle';
  toggleButton.setAttribute('aria-label', 'Toggle mobile menu');
  toggleButton.setAttribute('aria-expanded', 'false');
  
  // SVG icons
  const hamburgerIcon = `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 12H21" stroke="#000215" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M3 6H21" stroke="#000215" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M3 18H21" stroke="#000215" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;
  
  const closeIcon = `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 6L6 18" stroke="#000215" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6 6L18 18" stroke="#000215" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;
  
  toggleButton.innerHTML = hamburgerIcon;

  // Append button at the end of header
  headerGroup.appendChild(toggleButton);

  // Toggle menu function
  const toggleMenu = () => {
    const isOpen = toggleButton.getAttribute('aria-expanded') === 'true';
    
    if (isOpen) {
      // Close menu
      navWrapper.classList.remove('mobile-menu-open');
      toggleButton.setAttribute('aria-expanded', 'false');
      toggleButton.innerHTML = hamburgerIcon;
    } else {
      // Open menu
      navWrapper.classList.add('mobile-menu-open');
      toggleButton.setAttribute('aria-expanded', 'true');
      toggleButton.innerHTML = closeIcon;
    }
  };

  // Add click event listener
  toggleButton.addEventListener('click', (e) => {
    e.stopPropagation();
    toggleMenu();
  });

  // Close menu when clicking outside
  document.addEventListener('click', (e) => {
    if (!headerGroup.contains(e.target) && toggleButton.getAttribute('aria-expanded') === 'true') {
      toggleMenu();
    }
  });

  // Reset menu state on resize to lg breakpoint
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      const lgBreakpoint = 1024; // lg breakpoint (default Tailwind)
      if (window.innerWidth >= lgBreakpoint) {
        navWrapper.classList.remove('mobile-menu-open');
        toggleButton.setAttribute('aria-expanded', 'false');
        toggleButton.innerHTML = hamburgerIcon;
      } else {
        // Always close menu when switching to mobile
        navWrapper.classList.remove('mobile-menu-open');
        toggleButton.setAttribute('aria-expanded', 'false');
        toggleButton.innerHTML = hamburgerIcon;
      }
    }, 250);
  });
});
